import axios, { AxiosInstance } from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';

// axios 인스턴스 생성
export const client: AxiosInstance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// 요청 인터셉터 - 토큰 자동 추가
client.interceptors.request.use(
  (config) => {
    const token = getAuthToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } 
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 응답 인터셉터 - 401 에러 처리
client.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      removeAuthToken();
      removeUserData();
      window.location.href = '/auth';
    }
    return Promise.reject(error);
  }
);

export const getAuthToken = (): string | null => {
  return localStorage.getItem('authToken');
};

export const getUserData = () => {
  const userData = localStorage.getItem('userData');
  return userData ? JSON.parse(userData) as any : null;
};

export const setAuthToken = (token: string): void => {
  localStorage.setItem('authToken', token);
};

export const setUserData = (userData: unknown): void => {
  localStorage.setItem('userData', JSON.stringify(userData));
};

export const removeAuthToken = (): void => {
  localStorage.removeItem('authToken');
};

export const removeUserData = (): void => {
  localStorage.removeItem('userData');
};